<template>
	<div class="address">
		<van-nav-bar :title="title" @click-left="goBack">
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" />
			</template>
			<template #right>
				<van-icon name="delete" class="color_red" @click="onDelAddress"/>
			</template>
		</van-nav-bar>
		<div class="group-content">
			<van-address-list
			  v-model="chosenAddressId"
			  :list="chosenAddress"
			  default-tag-text="默认"
			  @add="onAddAddress"
			  @edit="onEditAddress"
			>
			</van-address-list>
		</div>

		<van-popup v-model="showEditAddress" round position="bottom" :style="{ 'max-height': '80%' }">
			<UserAddressInfo :adrInfo="addressInfo" @callAfterSave="afterSaveAddress"></UserAddressInfo>
		</van-popup>
	</div>
</template>

<script>
import {AddressList } from "vant";
import UserAddressInfo from "@/components/User/UserAddressInfo";

export default {
	name: "addresses",
	components: {
		"van-address-list":AddressList,
		UserAddressInfo
	},
	data() {
		return {
			title: "收货地址管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			chosenAddressId:-1,
			chosenAddress:[],
			addressInfoObj:{},
			showEditAddress:false,
			addressInfo:{}
		};
	},
	created() {
		this.getMyAddress();
	},
	computed: {
	},
	methods: {
		goBack() {
			this.$router.push({ name: "Set" });
		},
		getMyAddress(){
			var params = {
				u_id:this.u_id,
				token:this.token,
			};
			let that = this;
			var url = this.Conf.serverUrl + "User/address" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.chosenAddress = [];
				that.chosenAddressId = -1;
				that.addressInfoObj = {};
				for(var i in response.data.address){
					that.chosenAddress.push({
					  id: response.data.address[i]['id'],
					  name: response.data.address[i]['name'],
					  tel: response.data.address[i]['telphone'],
					  address: response.data.address[i]['area']+' '+response.data.address[i]['address'],
					  isDefault: response.data.address[i]['defaults']==1,
					});
					that.addressInfoObj[response.data.address[i]['id']] = response.data.address[i];
				};
			})
			.catch(error => {});
		},
		onAddAddress(){
			this.addressInfo = {};
			this.showEditAddress = true;
		},
		onEditAddress(item, ind){
			this.addressInfo = this.addressInfoObj[item.id];
			this.showEditAddress = true;
		},
		onDelAddress(){
			if(this.chosenAddressId == -1){
				this.$toast.fail("请选择或新增地址！");
				return false;
			}
			var params = {
				u_id:this.u_id,
				token:this.token,
				id:this.chosenAddressId
			};
			let that = this;
			var url = this.Conf.serverUrl + "User/delAddress" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.$toast.success(response.data.msg);
				that.getMyAddress();
			})
			.catch(error => {});
		},
		afterSaveAddress(){
			this.showEditAddress = false;
			this.getMyAddress();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/My/Address.vue